import { AuthenticationService } from './../services/authentication.service';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'date',
  //pure: false
})
export class CustomDatePipe extends DatePipe implements PipeTransform {

  subscription: any;
  constructor(@Inject(LOCALE_ID) locale?: string, public appInitService?: AppInitService, private authService?: AuthenticationService) {
    super(locale);
    /* let localeId = this.getLocale.localeValue;
    super(localeId); */
    console.log("****************Custom Date Pipe");
  }

  get getLocale(): any {
    return JSON.parse(localStorage.getItem('appLocale'));
  }

  transform(value: any, args?: any): any {
    let dateFormat = args ? args : this.getLocale.dateFormat;
    return this.dateFormatFromLocal(value, dateFormat)
  }

  dateFormatFromLocal(value, type) {
    switch (type) {
      case 'longDate':
        return super.transform(value, this.getLocale.longDateFormat)
      case 'shortDate':
        return super.transform(value, this.getLocale.shortDateFormat);
      case 'mediumDate':
        return super.transform(value, this.getLocale.mediumDateFormat);
      case 'fullDate':
        return super.transform(value, this.getLocale.fullDateFormat);
      default:
        return super.transform(value, type);
    }
  }

}
